import { DateTime } from 'luxon'

/**
 * calculates the age from the current year
 * date param can be a string or a Date
 */
export const getAge = (date) => {
  if (!date) return null // Handle invalid or missing date

  const inputDate = DateTime.fromISO(date) // Assumes the date is in ISO format
  if (!inputDate.isValid) return null // Handle invalid date formats

  const now = DateTime.now()
  const age = now.diff(inputDate, 'years').years // Calculate the age difference in years

  return Math.floor(age) // Return the integer value for age
}

export default function (date) {
  return {
    formatDate: (format) => DateTime.fromJSDate(date).format(format || 'dd/MM/yyyy')
  }
}
